// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import PhoneIcon from '@material-ui/icons/Phone';
import classnames from 'classnames';

import * as serviceActions from './actions';
import * as serviceSelectors from './selectors';
import * as coreSelectors from '../core/selectors';
import * as coreActions from '../core/actions';
import * as phoneActions from '../phone/actions';

import OutlinedPopover from '../ui/OutlinedPopover';
// import PhoneTextField from '../ui/PhoneTextField';
import PhoneTextFieldWithFlag from '../ui/PhoneTextFieldWithFlag';


const styles = theme => ({
  title : {
    ...theme.typography.h6,
    marginBottom: 20,
    width: '60vw',
  },
  dataTop : {
    display: 'flex',
    flexWrap:'wrap',
    alignItems: 'stretch',
  },
  mainInfo : {
    flexGrow: 1,
    flexBasis: '40%',
    display: 'flex',
    marginTop: 10,
    flexDirection: 'column',
    alignItems: 'stretch',
    '& .MuiFormControl-root' : {
      marginBottom: 10,
    },
  },
  popOverDialogue: {
    '& .MuiPaper-root':{
      margin:'10px'
    },
    [theme.breakpoints.up('sm')]:{
      padding: '20px'
   },
    [theme.breakpoints.up('md')]:{
      padding: '32px'
   },
  },
  popOverContainer: {
    padding:'15px 10px',
    [theme.breakpoints.up('sm')]:{
      padding: '15px 15px'
   },
    [theme.breakpoints.up('md')]:{
      padding: '15px 20px'
   },
   '&.MuiPaper-root':{
    margin:0
   }
  },
  contactMethods : {
    width: "100%",
    padding: '0 3px',
    
    [theme.breakpoints.up('md')]:{
       padding: '0 10%'
    },
  },
  concactMethod: {
    display:'flex',
    flexDirection:'column',
    margin: '15px 0',
    '& .MuiButtonBase-root':{
      padding:'0 2px'
    },
    '& > div:first-child':{
      display:'flex'
    },
    '& h4':{
      fontFamily: 'Sofia-bold',
      fontWeight: '400',
      color: '#000',
      margin:0
    }
  },
  contactMethodEntry: {
    display:"flex",
    flexDirection:'column',
    [theme.breakpoints.up('sm')]:{
      flexDirection:'row',
   },
    '& > .contactMethodRow:last-child':{
      alignSelf:'center'
    }
  },
  contactMethodRow: {
    // marginTop: '-32px',
    // marginLeft: 10,
    // marginRight: 10,
    // marginBottom: 32,
    display: 'flex',
    alignItems: 'flex-end',
    margin:'3px 0'

  },
  sectionHeader : {
    color: '#000',
  },
  icon: {
    color: theme.palette.icon.main,
  },
  buttons : {
    marginTop: 10,
    textAlign: 'center',
  },

  contactDeleted: {
    textDecoration: 'line-through',
    textDecorationColor: 'red',
  },
  
});


/*
 * Display a popover when clicking on a message
 */
class Contact extends Component {
  state = {
    confirmClose : false,
    warningOpen: false,
    warningUser: "",
    validPhones: []
  }
  
  componentDidMount() {
  }
  
  componentDidUpdate() {
  }

  /*
   * Update a primary field
   */
  updatePrimaryField(fieldName, newValue) {
    let contact = { ...this.props.contact };
    contact[fieldName] = newValue;
    contact.changed = true;
    this.props.setContact(contact);
    if (!this.props.contactChanged) {
      this.props.setContactChanged(true);
    }
  }

  /*
   * Update a contact method field
   */
  updateMethodField(contactMethodId, fieldName, newValue) {
    let contact = { ...this.props.contact };
    let index = contact
      .contactMethods.findIndex(method => method.contactMethodId === contactMethodId);
    if (index < 0) {
      return;
    }
    let contactMethods = [ ...this.props.contact.contactMethods ];    
    let contactMethod = { ...contactMethods[index] };
    contactMethod[fieldName] = newValue;
    contactMethod.changed = true;
    contactMethods[index] = contactMethod;
    this.props.setContact({...this.props.contact,
                           contactMethods });
    if (!this.props.contactChanged) {
      this.props.setContactChanged(true);
    }
  }
  
  /*
   * Toggle delete flag on item
   */
  deleteMethod(contactMethodId) {
    let contact = { ...this.props.contact };
    let index = contact
      .contactMethods.findIndex(method => method.contactMethodId === contactMethodId);
    if (index < 0) {
      return;
    }
    let contactMethods = [ ...this.props.contact.contactMethods ];    
    let contactMethod = { ...contactMethods[index] };
    contactMethod.changed = true;
    contactMethod.deleted = !contactMethod.deleted && true;
    contactMethods[index] = contactMethod;
    this.props.setContact({...this.props.contact,
                           contactMethods });
    if (!this.props.contactChanged) {
      this.props.setContactChanged(true);
    }
    this.updateValidPhones(contactMethodId, true);
  }

  /* Prompt to save if closing with unsaved changes */
  checkClose = () => {
    if (!this.props.contactChanged) {
      this.props.setContactOpen(false);
    } else {
      this.setState({confirmClose: true});
    }
  }

  /* Create a new temporary primary key for a new record.  They are
     prefixed with 'N' to avoid any conflict with the real primary keys */
  nextNewId = () => {
    let newMethods=this.props.contact.contactMethods
                       .filter(contactMethod => String(contactMethod.contactMethodId)
                         .startsWith('N'))
                       .sort();
    let contactMethodId = 'N00001';
    if (newMethods.length > 0) {
      contactMethodId = 'N' + String(Number(newMethods[newMethods.length-1]
        .contactMethodId.substring(1)) + 1)
        .padStart(5, '0');
    }
    return(contactMethodId);
  }

  /* 
   * Add an new empty phone number 
   */
  addPhoneNumber = () => {
    let contactMethodId = this.nextNewId();
    
    let contactMethods = [ ...this.props.contact.contactMethods ];
    contactMethods.push({ contactMethodId,
                          changed: true,                          
                          description : 'Office',
                          contactMethodType : 'PHONE', phone: '',
                          phoneExtension: '' });
    this.props.setContact({...this.props.contact,
                           contactMethods });
    this.updateValidPhones(contactMethodId, false);
    if (!this.props.contactChanged) {
      this.props.setContactChanged(true);
    }
    window.dispatchEvent(new Event("resize") );
  }
  
  /* 
   * Add an new empty email  
   */
  addEmail = () => {
    let contactMethodId = this.nextNewId();
    
    let contactMethods = [ ...this.props.contact.contactMethods ];
    contactMethods.push({ contactMethodId,
                          changed: true,                          
                          description : 'Office',
                          contactMethodType : 'EMAIL', email: ''});
    this.props.setContact({...this.props.contact,
                           contactMethods });
    if (!this.props.contactChanged) {
      this.props.setContactChanged(true);
    }
    
    window.dispatchEvent(new Event("resize") );
  }

  /* Save and keep open unless a new contact */
  saveAndKeepOpen = () => {
    this.props.setContactChanged(false);
    this.props.saveContact({...this.props.contact});
  }

  updateValidPhones(updateId, valid) {
    var newPhones = this.state.validPhones;
    newPhones[updateId] = valid;
    for (var data of this.props.contact.contactMethods){
      if(data['deleted']) {
        newPhones[data['contactMethodId']] = true;
      }
    }
    this.setState({validPhones: newPhones});
  }

  checkInvalidEmails(){
    if(this.props.contact?.contactMethods){
      for(var data of this.props.contact?.contactMethods?.filter(item => item.contactMethodType === 'EMAIL')){
        if(!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}))$/.test(data.email)) && data.email !== '' && data.email !== undefined){
          return true;
        }
      }
    }
    return false;
  }

  checkAtleastOneContactMethod() {
    if(this.props.contact?.contactMethods){
      for(var data of this.props.contact.contactMethods){
        if(data.contactMethodType === 'EMAIL' && data.email !== null && data.email !== undefined){
          return true;
        }
        if(data.contactMethodType === 'PHONE' && data.phoneNumber !== null && data.phoneNumber !== undefined){
          return true;
        }
      }
    }
  }
  

  saveAndClose = () => {
    var create = true;
    if(this.props.user.contacts && this.props.contact.contactId === 'new'){
      this.props.user.contacts.forEach(item => {
        (item.contactMethods || [])
                  .filter(method=>method.contactMethodType==='PHONE').forEach(con => {
                    (this.props.contact.contactMethods || [])
                      .filter(method=>method.contactMethodType==='PHONE').forEach(newCon => {
                        if(newCon.phoneNumber === con.phoneNumber){
                          create = false;
                          this.setState({warningOpen: true, warningUser: item.displayName})
                        }
                      })
                  })
      })
    }
    if(create){
      this.props.saveContact(this.props.contact);   
    } 
    this.setState({confirmClose: false });
    this.props.setContactOpen(false);
  }

  callClicked = (method) => {
    this.props.setOutdialNumber(method.phoneNumber);
    this.props.setContactOpen(false);
    this.props.setPhoneOpen(true);
  }
  
  
  render() {
    const { classes, contactOpen, setContactOpen,
            contact, contactChanged, user, setAddContactLink,
            updateUser } = this.props;

    return (
      <React.Fragment>
        <MuiCore.Dialog open={this.state.confirmClose}
          onClose={() => this.setState({ confirmClose: false })}>
          <MuiCore.DialogTitle>
            <span style={{ fontFamily: 'Sofia-bold' }}>Unsaved Changes</span>
          </MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.DialogContentText>
              This contact has unsaved changes.
            </MuiCore.DialogContentText>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
            <MuiCore.Button onClick={this.saveAndClose}>
              {contact.contactId === 'new' ? 'Create Contact' : 'Save Changes'}
            </MuiCore.Button>
            <MuiCore.Button onClick={() => {
              setContactOpen(false);
              setAddContactLink(undefined);
              updateUser();
              this.setState({ confirmClose: false });
            }}>
              Discard Changes
            </MuiCore.Button>
            <MuiCore.Button onClick={() => this.setState({ confirmClose: false })}>
              Keep Editing
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
        <MuiCore.Dialog open={this.state.warningOpen}
          onClose={() => this.setState({ warningOpen: false })}>
          <MuiCore.DialogTitle>
            <span style={{ fontFamily: 'Sofia-bold' }}>Contact exists</span>
          </MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.DialogContentText>
              {`This contact number already exists for ${this.state.warningUser}`}.
            </MuiCore.DialogContentText>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
            <MuiCore.Button onClick={() => this.setState({ warningOpen: false, warningUser: '' })}>
              OK
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
        <OutlinedPopover
        classes={{
          root: classes.popOverContainer,
          popper: classes.popOverDialogue
        }}
        open={contactOpen}
          icon={<PersonIcon className={classes.icon} fontSize='large' />}
          setContactOpen={setContactOpen}
          title={!contact.displayName ? 'New Contact' : contact.displayName}
          onClose={this.checkClose}>
          <div className={classes.dataTop}>
            <div className={classes.mainInfo}>
              <MuiCore.TextField
                variant='outlined'
                autoFocus={true}
                onChange={(event) => this.updatePrimaryField('firstName', event.target.value)}
                // label='First Name'
                InputProps={{ style: { fontFamily: 'Sofia', fontSize: 14 } }}
                placeholder='First Name'
                InputLabelProps={{ shrink: true }}
                value={contact.firstName || ''} />
              <MuiCore.TextField
                variant='outlined'
                onChange={(event) => this.updatePrimaryField('lastName', event.target.value)}
                // label='Last Name'
                InputProps={{ style: { fontFamily: 'Sofia', fontSize: 14 } }}
                placeholder='Last Name'
                InputLabelProps={{ shrink: true }}
                value={contact.lastName || ''} />
              <MuiCore.TextField
                variant='outlined'
                onChange={(event) => this.updatePrimaryField('title', event.target.value)}
                // label='Title'
                InputProps={{ style: { fontFamily: 'Sofia', fontSize: 14 } }}
                placeholder='Title'
                InputLabelProps={{ shrink: true }}
                value={contact.title || ''} />
              <MuiCore.TextField
                variant='outlined'
                onChange={(event) => this.updatePrimaryField('business', event.target.value)}
                // label='Business'
                InputProps={{ style: { fontFamily: 'Sofia', fontSize: 14 } }}
                placeholder='Company'
                InputLabelProps={{ shrink: true }}
                value={contact.business || ''} />
            </div>
            <div className={classes.contactMethods}>
              <div className={classes.concactMethod}>
                <div>
                  <h4>Phone Numbers</h4>
                  <MuiCore.IconButton onClick={this.addPhoneNumber}>
                    <AddIcon />
                  </MuiCore.IconButton>
                </div>
                {(contact.contactMethods || [])
                  .filter(method => method.contactMethodType === 'PHONE' && (!method.deleted))
                  .map(method => {
                    return (
                      <div className={classes.contactMethodEntry} key={method.contactMethodId}>
                        <div
                          className={classnames(classes.contactMethodRow,
                            { [classes.contactDeleted]: method.deleted || false })}>
                          <MuiCore.Select
                            value={method.description}
                            onChange={(event) => {
                              this.updateMethodField(method.contactMethodId,
                                'description',
                                event.target.value);
                            }}
                            style={{ marginRight: 10, fontFamily: 'Sofia' }}>
                            <MuiCore.MenuItem value='Mobile' style={{ fontFamily: 'Sofia' }}>Mobile</MuiCore.MenuItem>
                            <MuiCore.MenuItem value='Office' style={{ fontFamily: 'Sofia' }}>Office</MuiCore.MenuItem>
                            <MuiCore.MenuItem value='Home' style={{ fontFamily: 'Sofia' }}>Home</MuiCore.MenuItem>
                          </MuiCore.Select>
                        </div>
                        <div className={classes.contactMethodRow}>
                          <PhoneTextFieldWithFlag variant='standard' deleted={method.deleted} value={method.phoneNumber} onPhoneNumberChange={(change) => {
                            this.updateMethodField(method.contactMethodId,
                              'phoneNumber',
                              change);
                          }} isValid={(valid) => this.updateValidPhones(method.contactMethodId, valid)} />
                          <div style={{ padding: 5 }}>X</div>
                          <MuiCore.TextField variant='standard'
                            value={method.phoneExtension}
                            type='text'
                            onChange={(event) => {
                              const value = event.target.value.replace(/[^0-9]/g, '')
                              this.updateMethodField(method.contactMethodId,
                                'phoneExtension',
                                value);
                            }}
                            style={{ width: '5em' }} />
                              <MuiCore.IconButton
                            disabled={user.patchNumbers.length === 0 || contactChanged || !this.state.validPhones[method.contactMethodId]}
                            onClick={() => this.callClicked(method)}>
                            <PhoneIcon color='#000' />
                          </MuiCore.IconButton>
                          <MuiCore.IconButton onClick={() => this.deleteMethod(method.contactMethodId)}>
                            <DeleteIcon color='#000' />
                          </MuiCore.IconButton>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className={classes.concactMethod}>
                <div>
                  <h4>Email Addresses</h4>
                  <MuiCore.IconButton onClick={this.addEmail}>
                    <AddIcon />
                  </MuiCore.IconButton>
                </div>

                {(contact.contactMethods || [])
                  .filter(method => method.contactMethodType === 'EMAIL' && (!method.deleted))
                  .map(method => {
                    return (
                      <div className={classes.contactMethodEntry} key={method.contactMethodId}>
                      <div 
                        className={classnames(classes.contactMethodRow,
                          { [classes.contactDeleted]: method.deleted || false })}>
                        <MuiCore.Select value={method.description} style={{ marginRight: 10, fontFamily: 'Sofia' }}
                          onChange={(event) => {
                            this.updateMethodField(method.contactMethodId,
                              'description',
                              event.target.value);
                          }}>
                          <MuiCore.MenuItem value='Office' style={{ fontFamily: 'Sofia' }}>Office</MuiCore.MenuItem>
                          <MuiCore.MenuItem value='Home' style={{ fontFamily: 'Sofia' }}>Home</MuiCore.MenuItem>
                        </MuiCore.Select>
                       
                      </div>
                      <div className={classes.contactMethodRow}>
                      <MuiCore.TextField variant='standard'
                          onChange={(event) => {
                            const value = event.target.value.replace(/[`!#$%^&*()+\\=[\]{};':"\\|,<>/?~]/g, '')
                            this.updateMethodField(method.contactMethodId,
                              'email',
                              value);
                          }}
                          
                          type='email'
                          error={!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}))$/.test(method.email))}
                          style={{ flexGrow: 1 }}
                          value={method.email || ''} />
                        <MuiCore.IconButton onClick={() => this.deleteMethod(method.contactMethodId)}>
                          <DeleteIcon color='#000' />
                        </MuiCore.IconButton>
                        </div>  
                        </div>
                    );
                  })}

              </div>
            </div>
          </div>
          <div className={classes.buttons}>
            <MuiCore.Button disabled={!contactChanged || Object.values(this.state.validPhones).includes(false) || this.checkInvalidEmails() || contact?.contactMethods?.filter(method => !method.deleted && ((method.contactMethodType === 'PHONE' && method.phoneNumber?.length > 10) || (method.contactMethodType === 'EMAIL' && method.email?.length > 0))).length === 0 || !this.checkAtleastOneContactMethod()}
              onClick={this.saveAndClose}>
              {contact.contactId === 'new' ? 'Save' : 'Save Changes'}
            </MuiCore.Button>
          </div>
        </OutlinedPopover>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    contact : serviceSelectors.getContact(state),
    contactOpen : serviceSelectors.getContactOpen(state),
    contactChanged : serviceSelectors.getContactChanged(state),
  });
};

const mapDispatchToProps = {
  setContact : serviceActions.setContact,
  setContactOpen : serviceActions.setContactOpen,
  setContactChanged : serviceActions.setContactChanged,
  saveContact : serviceActions.saveContact,
  setOutdialNumber : phoneActions.setOutdialNumber,
  setPhoneOpen : phoneActions.setPhoneOpen,
  setAddContactLink : serviceActions.setAddContactLink,
  updateUser: coreActions.updateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Contact));

